module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/inverse-2x.044d933f30c91ac672f178853c8a716d.png";